import React, { useEffect, useState } from 'react';
import classes from './hamburger.module.scss';
import cn from 'classnames';
import BackMenu from '@assets/images/Fireboard/BackMenu';
import ReactSelector from '../Common/ReactSelector';
import ListViewIcon from '@assets/images/Fireboard/ListView';
import TileViewIcon from '@assets/images/Fireboard/TileView';
import CubbyIcon from '@assets/images/Fireboard/CubbyView';
import OrderStatusIcon from '@assets/images/Fireboard/OrderStatus';
import GeneralModeIcon from '@assets/images/Fireboard/MODES/GeneralMode';
import OffPremiseIcon from '@assets/images/Fireboard/MODES/OffPremiseIcon';
import OnPremiseIcon from '@assets/images/Fireboard/MODES/OnPremiseIcon';
import OnPremiseVenueIcon from '@assets/images/Fireboard/MODES/OnPremiseVenueIcon';
import TableDeliveryIcon from '@assets/images/Fireboard/MODES/TableDelivery';
import NewsMode from '@assets/images/Fireboard/NewsMode';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import {
  otherViewTypes,
  otherModeTypes,
  hamburgerOptions,
} from '../Header/constants';
const HamburgerMenu = props => {
  const {
    onClickHamburger,
    onChangeView,
    currentView,
    currentMode,
    onChangeMode,
    setIsFlip,
    handleHambugerScreens,
  } = props;
  const [defaultValue, setDefaultValue] = useState(currentView);
  const [defaultMode, setDefaultMode] = useState(currentMode);
  const labels = FLABEL();

  const mapWithLabels = (list, labels) =>
    list?.map(item => ({
      ...item,
      name: labels[item?.nameKey],
    }));
  const viewOptions = mapWithLabels(otherViewTypes, labels);
  const modeOptions = mapWithLabels(otherModeTypes, labels);
  const hamburgerOptionsMap = mapWithLabels(hamburgerOptions, labels);

  const selectedViewOption =
    viewOptions?.find(option => option?.type === defaultValue) || viewOptions[0];
  const selectedModeOption =
    modeOptions?.find(option => option?.type === defaultMode) || modeOptions[0];

  useEffect(() => {
    if (currentView) {
      setDefaultValue(currentView);
    }
  }, [currentView]);

  const getViewIcon = option => {
    const icons = {
      0: <ListViewIcon height={'30'} width={'30'} />,
      1: <TileViewIcon height={'30'} width={'30'} />,
      2: <CubbyIcon height={'30'} width={'30'} />,
      3: <OrderStatusIcon height={'30'} width={'30'} />,
    };
    return icons[option.id] || null;
  };

  const getModeIcon = option => {
    const icons = {
      0: <GeneralModeIcon />,
      1: <OffPremiseIcon />,
      2: <OnPremiseIcon />,
      3: <OnPremiseVenueIcon />,
      4: <TableDeliveryIcon />,
    };
    return icons[option.id] || null;
  };

  return (
    <div className={cn(classes.menuContainer, 'h-100 col-12')}>
      <div className="col-12 px-0 pt-1 pb-4 d-flex align-items-center justify-content-end">
        <div
          className={cn(classes.backButton)}
          onClick={() => onClickHamburger(false)}
        >
          <BackMenu />
        </div>
      </div>
      <div
        className={cn(
          'row mx-0 col-12 px-0 align-items-center overflowY',
          classes.menuListContainer
        )}
      >
        <div className="col-10 px-0"></div>

        <div className={cn('col-12 px-0 pb-3')}>
          <ReactSelector
            className={cn(classes.selecter)}
            onChange={data => {
              setDefaultValue(data?.type);
              onChangeView(data?.type);
            }}
            options={viewOptions}
            name="views"
            defaultValue={selectedViewOption?.id}
            customLabel={labels?.HAMBURGER_VIEWS}
            getIcon={getViewIcon}
          />
        </div>
        <div className={cn('col-12 px-0 mt-4 pb-4')}>
          <ReactSelector
            onChange={data => {
              setDefaultMode(data?.type);
              onChangeMode(data?.type);
              setIsFlip(false);
            }}
            options={modeOptions}
            name="modes"
            defaultValue={selectedModeOption?.id}
            customLabel={labels?.HAMBURGER_MODES}
            getIcon={getModeIcon}
          />
        </div>
        <div className="col-12 px-0">
          {hamburgerOptionsMap?.map((el, index) => {
            const lastElement = hamburgerOptionsMap?.length - 1;
            return (
              <div
                className={cn(
                  classes.singleMenuContainer,
                  'col-12 ',
                  lastElement === index && 'border-0'
                )}
                onClick={() => {
                  onClickHamburger(false);
                  handleHambugerScreens(el?.value);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className={classes.newsModeIcon}>
                    <NewsMode />
                  </div>
                  <div>{el?.name}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default HamburgerMenu;
